import { Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { getTransportLabelSx } from './transportTypographySx';

YesNoToggle.propTypes = {
  title: PropTypes.string,
  setter: PropTypes.func.isRequired,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
  titleSx: PropTypes.object,
  detailsMode: PropTypes.bool,
};

export default function YesNoToggle({
  title = '',
  setter,
  value,
  disabled = false,
  sx = {},
  titleSx = {},
  detailsMode = false,
}) {
  return (
    <Grid container alignItems="center" wrap="nowrap" spacing={1} sx={{ ...sx }}>
      <Grid item>
        <Typography color="text.secondary" sx={{ ...getTransportLabelSx(detailsMode), mr: 1, ...titleSx }}>
          {title}
        </Typography>
      </Grid>
      <Grid item>
        <ToggleButtonGroup exclusive value={value} onChange={(_, tab) => setter(tab)} size="small" disabled={disabled}>
          <ToggleButton value>YES</ToggleButton>
          <ToggleButton value={false}>NO</ToggleButton>
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
}
